import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuPalette, LuRocket, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const EventManagementHeroData = {
  backgroundImage: "/images/serviceBanners/EventManagement.webp",
  whiteImage: "/images/serviceBanners/EventManagementW.webp",
  subTitle: "Event Management & Brand Promotion Services",
  title: (
    <>
      High Performance <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Brand Experience</span>
      <br /> Systems
    </>
  ),
  description:
    "Event management and brand experience systems that combine physical and digital engagement to enhance brand visibility, create emotional connections, and generate measurable business impact through well executed experiential marketing strategies.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "End to End Event Planning",
      desc: "Concept, logistics, venue coordination, and execution.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Trade Show Management",
      desc: "High-ROI booth designs and lead-capture systems.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Brand Activation Campaigns",
      desc: "Immersive experiences, pop-ups, and product demos.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Hybrid & Virtual Production",
      desc: "Flawless streaming and digital engagement solutions.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const eventManagementAboutData = [
  {
    title: "Event Management Services for Memorable Brand Experiences",
    content: (
      <>
        Successful events create opportunities for businesses to connect directly with customers, partners, and stakeholders in meaningful ways. Professional Event Management
        Services help organizations plan and execute experiences that strengthen brand visibility and generate measurable business value. Many companies invest significant
        resources into events but struggle to maximize engagement and long term impact. At Tycho Technologies, event strategies are designed around audience expectations, business
        objectives, and brand storytelling to create experiences that leave a lasting impression.
      </>
    ),
  },
  {
    title: "Brand Promotion Services That Increase Market Visibility",
    content: (
      <>
        Building awareness requires more than traditional advertising. Effective Brand Promotion Services help businesses create stronger connections with their target audience
        through strategic experiences and meaningful interactions. Organizations that invest in brand focused events often improve recognition because customers engage with the
        brand in a more personal and memorable environment. Tycho Technologies develops promotional strategies that help businesses strengthen credibility, increase audience
        engagement, and expand their market presence.
      </>
    ),
  },
  {
    title: "Corporate Event Management Services for Business Growth",
    content: (
      <>
        Corporate events provide valuable opportunities to build relationships, showcase expertise, and strengthen professional networks. Reliable Corporate Event Management
        Services help businesses deliver well organized experiences that align with company goals and audience expectations. From product launches and conferences to networking
        events and business gatherings, a structured event strategy can improve participation and create stronger opportunities for lead generation. Well executed events also
        contribute to stronger brand trust and long term business development.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Brand Activation Services",
    content: (
      <>
        The demand for Exhibition & Trade Show Management Services continues to grow as organizations seek more engaging ways to connect with potential customers. Businesses
        investing in Brand Activation Services often focus on creating interactive experiences that increase participation and improve brand recall. Companies partnering with Tycho
        Technologies gain access to customized event and activation strategies designed around measurable business objectives and audience engagement goals. A strategic event
        management approach helps organizations strengthen visibility, improve customer interaction, and create sustainable brand growth through memorable real world experiences.
      </>
    ),
  },
];

export const eventManagementDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Event Management & Brand Promotion Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "End to End Event Planning & Execution",
      desc: "Handle complete event lifecycle including concept creation, venue selection, logistics, vendor coordination, and on ground execution.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Trade Show & Exhibition Management",
      desc: "Design booths, manage lead capture systems, and execute follow up strategies for maximum ROI from exhibitions and expos.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Brand Activation Campaigns",
      desc: "Create immersive brand experiences through pop ups, product demos, and interactive engagement setups.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Hybrid & Virtual Event Production",
      desc: "Manage live streaming, virtual events, webinars, and digital engagement for online audiences.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Pre Event Marketing Amplification",
      desc: "Run digital campaigns, invitations, PR outreach, and social media buzz before the event starts.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Post Event Brand Amplification",
      desc: "Repurpose event content into social media, video content, and campaigns to extend brand reach and impact.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Event Management Engineering Framework",
  processTitle: "How We Build Scalable Event & Brand Experience Systems",
  processSteps: [
    {
      step: "01",
      title: "Event Strategy & Planning",
      description: "Define event goals, audience targeting, and execution roadmap for maximum impact.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Event Execution",
      description: "Manage real time coordination, updates, and execution improvements during events.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Event Experience Development",
      description: "Design immersive brand experiences including booths, activations, and interactive setups.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Audience & Engagement Management",
      description: "Handle attendee engagement, interaction flow, and participation systems.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "Improve event reach, lead generation, and engagement using data insights.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance & Execution Control",
      description: "Ensure smooth execution, coordination accuracy, and high quality brand experience delivery.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN EVENT MANAGEMENT SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Event Management Systems",
  benefits: [
    "Strong brand visibility and awareness",
    "Real world customer engagement",
    "Higher lead generation opportunities",
    "Better brand recall and trust",
    "Multi channel promotion impact",
    "Measurable event ROI",
    "Scalable brand experience model",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const eventManagementServices = [
  {
    icon: <LuSmartphone size={36} />,
    title: "Corporate Conferences & Seminars",
    description: "Plan and host well-organized corporate events, product launches, and networking conferences.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/event-management-brand-promotion-services-india#corporate-events",
  },
  {
    icon: <LuBuilding2 size={36} />,
    title: "Exhibitions & Trade Shows",
    description: "Design premium exhibition booths and set up robust lead capture mechanisms for expos.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/event-management-brand-promotion-services-india#trade-shows",
  },
  {
    icon: <LuUsers size={36} />,
    title: "Interactive Brand Activations",
    description: "Immersive experiences, interactive popup setups, and demo environments to engage users.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/event-management-brand-promotion-services-india#brand-activations",
  },
];

export const eventManagementFaqData = [
  {
    q: "What types of events do your Event Management Services cover?",
    a: "We manage a wide range of corporate and promotional events, including corporate conferences, trade show exhibitions, product launches, brand activation pop-ups, hybrid/virtual event productions, and promotional seminars.",
  },
  {
    q: "How does Exhibition and Trade Show Management help maximize booth ROI?",
    a: "We handle the entire exhibition setup: from eye-catching booth layouts and interactive experience designs to integrating lead-capture software and planning post-event automated follow-ups. This ensures high attendee engagement and measurable lead generation.",
  },
  {
    q: "What is Brand Activation and why is it important?",
    a: "Brand activation is the process of building customer relationships through memorable, interactive real-world experiences (like pop-up stands, product samplings, or hands-on tech demos). It drives direct consumer engagement, increases brand recall, and builds trust.",
  },
  {
    q: "Can Tycho Technologies assist with digital pre-event and post-event promotion?",
    a: "Yes. Our end-to-end framework includes digital pre-event marketing campaigns (social media buzz, PR, invitations) as well as post-event content amplification (repurposing recordings, highlights, and follow-up email flows) to maximize long-term campaign impact.",
  },
];

export const eventManagementPortfolioData = {
  subtitle: "OUR WORK",
  title: "Event Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
